import style from './Footer.module.scss';

function Footer() {
    return (
        <footer className={style.footer}>
            <h1>Developed by Kayo Ennrique</h1>
        </footer>
    )
}

export default Footer;